import {Component, Inject, OnInit} from '@angular/core';
import {Observable, of} from 'rxjs';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";

@Component({
  selector: 'app-view-attachment',
  templateUrl: './view-attachment.component.html',
  styleUrls: ['./view-attachment.component.scss']
})
export class ViewAttachmentComponent implements OnInit {
  base64: string;
  title: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) data,
    private dialogRef: MatDialogRef<ViewAttachmentComponent>
  ) {
    this.base64 = data
  }

  ngOnInit(): void {
    this.title = 'View Document';
  }

  closeThisModal(close: boolean) {
    if (close) {
      this.dialogRef.close();
    }
  }

}
